import { render, staticRenderFns } from "./CatalogAddButton.vue?vue&type=template&id=399a8080&scoped=true&"
import script from "./CatalogAddButton.vue?vue&type=script&lang=js&"
export * from "./CatalogAddButton.vue?vue&type=script&lang=js&"
import style0 from "./CatalogAddButton.vue?vue&type=style&index=0&id=399a8080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399a8080",
  null
  
)

export default component.exports